<template>
  <div class="lesson-featured-image">
    <div class="relative" :style="[customCss]">
      <div v-if="src">
        <img class="btn-radius w-full" :src="src" alt="" />
      </div>
      <div
        v-else
        class="image-bg-color image-content-color w-full h-40 px-5 btn-radius flex items-center justify-center text-white text-xl course-img-hover shadow-lg"
      >
        {{ name }}
      </div>

      <div
        v-if="!isPreview"
        class="flex items-center absolute right-0 bottom-0 mr-2 mb-2"
      >
        <div class="builder-image-picker lesson-image-picker img-picker">
          <image-picker
            :value="avatar"
            :primary="true"
            @change="updateFeaturedImage"
          ></image-picker>
          <i class="fa fas fa-camera" aria-hidden="true"></i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ImagePicker from '@groovepages/gd-ui-kit/components/ImagePickerModal';
export default {
  name: 'FeaturedImage',
  props: {
    isPreview: {
      type: Boolean,
      default: true,
    },
    src: {
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    getThemeSettings: {},
    avatar: {},
    businessNiche: {},
    updateFeaturedImage: {
      type: Function,
      required: true,
    },
  },
  components: {
    ImagePicker,
  },
  computed: {
    customCss() {
      return {
        '--section-bg-color': this.themeSettings.configuration_options
          .section_bg_color,
        '--section-content-color': this.themeSettings.configuration_options
          .section_content_color,
      };
    },
    themeSettings() {
      return this.getThemeSettings();
    },
  },
};
</script>
<style lang="scss">
.image-bg-color {
  background-color: var(--section-bg-color);
}
.image-content-color {
  color: var(--section-content-color);
}
.builder-image-picker {
  &.lesson-image-picker {
    right: 16px;
    bottom: 16px;
    z-index: revert;
    > .flex > button:before {
      color: #545671;
    }
    svg.fa-camera {
      color: #545671;
    }
  }
}
.lesson-featured-image {
  img {
    height: auto;
  }
  &.img-picker {
    height: 32px;
    background: hsla(0, 0%, 100%, 0.2);
    border-radius: 6px;
    padding: 5px 33px 5px 8px;
    margin: 0;
    .my-4 {
      margin: 0px;
    }
    button#gp-styleEditor-chooseImage {
      background: transparent;
      color: transparent;
      box-shadow: none;
      border: none;
      width: 100%;
      //font-size: 8px;
      position: absolute;
      top: 0px;
      left: 0px;
      &:hover,
      &:focus {
        background: transparent;
        box-shadow: none;
        border: none;
      }
    }
    &:before {
      content: 'Edit';
      font-size: 16px;
      font-weight: 600;
      color: #fefefe;
    }
  }
}
.builder-image-picker {
  position: absolute;
  z-index: 30;
  .h-20.border-dashed,
  .h-20.border-dashed + .flex-grow,
  .h-20.border-dashed + .flex-grow + .flex {
    display: none;
  }
  & > .flex > button {
    height: 32px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 6px;
    padding: 5px 33px 5px 8px;
    margin: 0;
    span {
      display: none;
    }
    &:before {
      content: 'Edit';
      font-size: 16px;
      font-weight: 600;
      color: #fefefe;
    }
  }
  height: 32px;
    background: hsla(0, 0%, 100%, 0.2);
    border-radius: 6px;
    padding: 5px 33px 5px 8px;
    margin: 0;
    .my-4 {
      margin: 0px;
    }
    button#gp-styleEditor-chooseImage {
      background: transparent;
      color: transparent;
      box-shadow: none;
      border: none;
      width: 100%;
      //font-size: 8px;
      position: absolute;
      top: 0px;
      left: 0px;
      &:hover,
      &:focus {
        background: transparent;
        box-shadow: none;
        border: none;
      }
    }
    &:before {
      content: 'Edit';
      font-size: 16px;
      font-weight: 600;
      color: #fefefe;
    }
  // &.img-picker {
  //   height: 32px;
  //   background: hsla(0, 0%, 100%, 0.2);
  //   border-radius: 6px;
  //   padding: 5px 33px 5px 8px;
  //   margin: 0;
  //   .my-4 {
  //     margin: 0px;
  //   }
  //   button#gp-styleEditor-chooseImage {
  //     background: transparent;
  //     color: transparent;
  //     box-shadow: none;
  //     border: none;
  //     width: 100%;
  //     //font-size: 8px;
  //     position: absolute;
  //     top: 0px;
  //     left: 0px;
  //     &:hover,
  //     &:focus {
  //       background: transparent;
  //       box-shadow: none;
  //       border: none;
  //     }
  //   }
  //   &:before {
  //     content: 'Edit';
  //     font-size: 16px;
  //     font-weight: 600;
  //     color: #fefefe;
  //   }
  // }
  svg.fa-camera {
    position: absolute;
    right: 8px;
    top: 8px;
    color: #fefefe;
    pointer-events: none;
  }
}
</style>
